export const A2P_REGISTRATION_TYPE_STARTER = 1
export const A2P_REGISTRATION_TYPE_STANDARD = 2

export const A2P_REGISTRATION_NAMES = {
    [A2P_REGISTRATION_TYPE_STARTER]: 'A2P 10DLC Registration Type: Starter',
    [A2P_REGISTRATION_TYPE_STANDARD]: 'A2P 10DLC Registration Type: Standard'
}

export const PURGING_STATUS_NOT_USED = 1
export const PURGING_STATUS_SCHEDULED = 2
export const PURGING_STATUS_NOTICED_BY_EMAIL = 3
export const PURGING_STATUS_ONGOING = 4
export const PURGING_STATUS_FAILED = 5

export const STATUS_PRIVATE = 1
export const STATUS_PUBLIC = 2

export const PRIVATE = 'private'
export const PUBLIC = 'public'

export const INTERNATIONAL_TIER_1 = 1
export const INTERNATIONAL_TIER_2 = 2
export const INTERNATIONAL_TIER_3 = 3
export const INTERNATIONAL_TIER_4 = 4
